// Подписи года на оси силуэта — ОДНА реализация на две стороны.
//
// Правило: текущий этап → `NOW`; датированный → `'YY` от начала; при отсутствии текущего
// последний тик берёт КОНЕЦ дуги, а не своё начало (канон-вариант 05 — иначе ось перестаёт
// сходиться с диапазоном «… → endY»); недатированный → `null`, подпись пропадает, геометрия
// держится. Дат нет вовсе → `null` на всю ось.
//
// ПОЧЕМУ ОТДЕЛЬНЫМ ФАЙЛОМ (cc-31). Функция жила внутри `SilhouetteChart.jsx`, и §I ходил в неё
// не вызовом, а передачей сырых `wizard.stages` в чарт — то есть состояние визарда доезжало до
// рендерера мимо шва, не называя `passport` ни разу. Теперь подписи считает шов (`viewI`), а
// чарт их печатает. Модуль plain-`.js` намеренно: шов `viewFromPassport.js` не должен зависеть
// от JSX — иначе он перестаёт грузиться обычным `node`, а на нём стоят скрипты сборки.

const yy = (y) => `'${String(Math.floor(y)).slice(-2)}`;

// `typeof x === 'number'` пропускает NaN, и ось печатала тик `'aN`. В `viewI` это починили
// коммитом 7250c4f, а вот в ЭТОМ файле — нет, хотя вынесен он был тем же коммитом. Классический
// след переезда: правило поехало в новый дом, а починка осталась в старом. Поймано QA cc-31.

/**
 * @param {Array|null} stages  этапы визарда (или null)
 * @param {number} N           число точек силуэта — оси должны совпасть 1:1
 * @param {number} cur         индекс текущего этапа, -1 если текущего нет
 * @returns {Array<string|null>|null}
 */
export function deriveTickLabels(stages, N, cur) {
  if (!Array.isArray(stages) || stages.length !== N) return null;
  const anyDate = stages.some((s) => Number.isFinite(s?.startY) || Number.isFinite(s?.endY));
  if (!anyDate) return null;
  // ПОДПИСЬ ПРИНАДЛЕЖИТ ГОДУ (формулировка Claude Design, ревью 21.08). Год подписывается ОДИН
  // раз — на левом вхождении; дедуп по значению, а не по соседству. Два этапа, начавшиеся в
  // разные месяцы одного года, — легальный ввод (валидатор ловит только равные десятичные), и
  // ось печатала «'00 '00 NOW». Первая версия снимала только соседний повтор; CD поправил: ось
  // обложки размечает ЭПОХИ, и один и тот же год не может быть размечен дважды, где бы второе
  // вхождение ни стояло. Месяцы — только §IV, здесь их не бывает. Деградация прежняя: подпись
  // снимается, геометрия держится (`s318.d1`).
  const used = new Set();
  const once = (label) => {
    if (label === null || label === 'NOW') return label;
    if (used.has(label)) return null;
    used.add(label);
    return label;
  };
  return stages.map((s, i) => once(tickOf(s, i)));

  function tickOf(s, i) {
    // «NOW» значит КОНЕЦ записанной жизни, а не «этот этап помечен флагом». При флаге на среднем
    // этапе ось печатала «'05 NOW '18» — NOW, справа от которого ещё два года. Подпись дуги это
    // уже отказывалась делать (`nowEndsArc`), ось — нет, и две формы на одном листе спорили.
    // Канон не двигается: там текущий этап последний либо его нет вовсе (QA cc-31).
    if (i === cur && cur === N - 1) return 'NOW';
    // Открытое начало = года у этапа нет. Без этой ветки тик падал на `endY`, а под моделью А
    // это начало СЛЕДУЮЩЕГО этапа — ось печатала один год дважды («'09 '09 NOW»). Канон F7,
    // варианты v06 / E4: `tickLabels[0] = null` — подпись пропадает, геометрия держится
    // (`s318.d1`). Поймано QA-прогоном cc-31.
    if (s?.openStart) return null;
    if (cur < 0 && i === N - 1 && Number.isFinite(s?.endY)) return yy(s.endY);
    if (Number.isFinite(s?.startY)) return yy(s.startY);
    if (Number.isFinite(s?.endY)) return yy(s.endY);
    return null;
  }
}
